/**
 * Per-page access guard for operations sub-pages. Admins see everything;
 * viewers see a page only if it's granted (deny-by-default). Admin-area pages
 * require operations-admin. Hub-gated (v1) — a future operations-service still
 * enforces the base `operations` claim, so this is a UX/segmentation layer.
 */
import type { ReactNode } from 'react';
import { isOperationsAdmin, canViewOperationsPage } from '@daaily/shared';
import { useProfile } from '../profile/ProfileProvider';

export function OperationsPageGuard({ entryKey, admin, children }: { entryKey: string; admin?: boolean; children: ReactNode }) {
  const { state } = useProfile();
  if (state.status !== 'ready') return null;
  const isAdmin = isOperationsAdmin({ isAppAdmin: state.isAdmin, role: state.user.tools?.operations?.role });
  const allowed = admin ? isAdmin : canViewOperationsPage(isAdmin, state.user.operationsPages ?? [], entryKey);
  if (allowed) return <>{children}</>;
  return (
    <main className="w-full max-w-form px-4 md:px-8 pt-6 pb-10">
      <div className="rounded-lg border border-line bg-surface px-6 py-10 text-center">
        <div className="text-sm font-medium text-fg">This page isn't provisioned for you</div>
        <p className="text-sm text-fg-faint mt-1.5">
          Ask an Operations admin to grant you access to this page.
        </p>
      </div>
    </main>
  );
}
